export default "__VITE_ASSET__e9020314__"